import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { BsData, UserBet } from "../../models/ExchBetSlip";
import { ONE_CLICK_BETTING_STAKES } from "../../constants/ButtonVariables";

export interface ExchBetSlipState {
  bets: BsData[];
  openBets: UserBet[];
  bettingInprogress: boolean;
  isOneClickBettingEnabled: boolean;
  oneClickBettingStake: number;
  customStakes: number[];
}

// Define the initial state
const initialState: ExchBetSlipState = {
  bets: [],
  openBets: [],
  bettingInprogress: false,
  isOneClickBettingEnabled: false,
  oneClickBettingStake: 0,
  customStakes: ONE_CLICK_BETTING_STAKES,
}

// Create a slice of the state with actions and reducers
const authSlice = createSlice({
  name: "exchBetSlip",
  initialState,
  reducers: {
    resetExchBetSlipState() {
      return initialState;
    },
    addExchangeBetHandler(state, action: PayloadAction<any>) {
      // console.log("clicked",action.payload)
      const bettingInprogress = state.bettingInprogress;
      if (!bettingInprogress) {
        let bets = [...state.bets];
        bets = [action.payload];
        return {
          ...state,
          bets,
          oddsChanged: false,
          betSuspended: false,
          message: '',
        };
      }
      return {
        ...state,
      };
    },
    exchangeBetOddsChange(state, action: PayloadAction<any>) {
      const bets = [...state.bets];
      if (bets[action?.payload?.index]) {
        bets[action?.payload?.index].oddValue = action.payload.odds
          ? action.payload.odds
          : null;
      }

      // return {
      //   ...state,
      //   bets,
      // };
    },

    removeExchangeBet(state, action: PayloadAction<any>) {
      const bets = [...state.bets];
      bets.splice(action.payload.index, 1);

      return {
        ...state,
        bets,
      };
    },

    setOpenBets(state, action: PayloadAction<any>) {
      state.openBets = action.payload;
    },

    setExchangeBetStake(state, action: PayloadAction<any>) {
      const bets = [...state.bets];
      if (action.payload.type === 'ADD') {
        bets[action.payload.index].stakeAmount += Math.floor(action.payload.amount);
      } else if (action.payload.type === 'SET') {
        bets[action.payload.index].stakeAmount = Math.floor(action.payload.amount);
      }

      if (isNaN(bets[action.payload.index].stakeAmount)) {
        bets[action.payload.index].stakeAmount = 0;
      }
    },

    clearExchangeBets(state, action: PayloadAction<any>) {
      const bettingInprogress = state.bettingInprogress;
      if (!bettingInprogress) {
        return {
          ...state,
          bets: [],
        };
      }
      return {
        ...state,
      };
    },
    setBettingInprogress(state, action: PayloadAction<any>) {
      return {
        ...state,
        bettingInprogress: action.payload,
      };
    },

    setIsOneClickBettingEnabled(state, action: PayloadAction<any>) {
      const isEnabled = action.payload;

      // If disabling one-click betting, reset stakes, custom stakes, and clear bets
      if (!isEnabled) {
        return {
          ...state,
          isOneClickBettingEnabled: isEnabled,
          oneClickBettingStake: 0,
          customStakes: ONE_CLICK_BETTING_STAKES, // Reset to default values
          bets: [], // Clear any existing bets
        };
      }

      return {
        ...state,
        isOneClickBettingEnabled: isEnabled,
      };
    },

    setOneClickBettingStake(state, action: PayloadAction<any>) {
      return {
        ...state,
        oneClickBettingStake: action.payload,
      };
    },

    setCustomStakes(state, action: PayloadAction<any>) {
      return {
        ...state,
        customStakes: action.payload,
      };
    },

    // Define other reducers here if needed
  },
});

// Export the actions generated by createSlice
export const { addExchangeBetHandler, exchangeBetOddsChange, removeExchangeBet, setExchangeBetStake, clearExchangeBets, setBettingInprogress, resetExchBetSlipState, setOpenBets, setIsOneClickBettingEnabled, setOneClickBettingStake, setCustomStakes } = authSlice.actions;

// Export the reducer to be used in the store
export default authSlice.reducer;